import { message, notification, Typography } from 'antd';
const { Text, Title } = Typography;

const endPoint = "https://social-media-data-donator.mpi-sws.org/api/";
// const endPoint = "http://localhost:8000/api/";
// const endPoint = "http://0.0.0.0:8000/api/";
// const endPoint = "http://social-media-data-donator-12:8000/api/";

/*
Arguments:
data: String. Stringified Json to be sent to backend.
destination: String. The extension of the backend address, e.g. "consents/".
onSuccess: Function. To be called if the data is successfully sent to the backend.
onFailure: Function. To be called if an error is encountered.
*/
export function SendToBackend(data, destination, onSuccess, onFailure) {
    //console.debug("Fetching from backend: ", endPoint + destination);
    var xml = new XMLHttpRequest();
    xml.withCredentials = true;
    xml.onreadystatechange = function () {
        if (xml.readyState === XMLHttpRequest.DONE && this.status === 200) {
            onSuccess();
        }
        else if (xml.readyState === XMLHttpRequest.DONE && this.status!=200) {
            onFailure();
        }
    }
    xml.open("POST", endPoint + destination);
    xml.setRequestHeader('Content-Type', 'application/json');
    xml.send(data);
    //console.debug(data);
}

/*
Arguments:
source: String. The extension of the backend address, e.g. "donations/".
onSuccess: Function. To be called if the data is successfully retrieved from the backend.
onFailure: Function. To be called if an error is encountered.
setFeature: Hook setter function. To be used to store the recieved data. e.g. setSessionId.
*/
export function FetchFromBackend(source, onSuccess, onFailure, setFeature) {
    //console.log("Fetching from backend: ", endPoint + source);
    var xml = new XMLHttpRequest()
    xml.onreadystatechange = function () {
        if (xml.readyState === XMLHttpRequest.DONE && this.status === 200) {
            setFeature(JSON.parse(xml.response));
            onSuccess();
            // console.log("Successful retrieval of ", endPoint + source);
        }
        else if (xml.readyState === XMLHttpRequest.DONE && this.status != 200) {
            onFailure();
            // console.log("Failed retrieval of ", endPoint + source);
	    // console.log("status code ", this.status);
        }
    }
    xml.open('GET', endPoint + source);
    // send the request
    xml.send();
}

export function ErrorConnectionFailed() {
    notification["error"]({
        message: <Text strong>{'Something went wrong'}</Text>,
        className: "Text",
        description:
            <div>
                <Text>{"Connection failed. Please try again. If the issue persists, please contact\n"}</Text>
                <Text strong>{"smousavi@mpi-sws.org"}</Text>
            </div>,
    });
}

//    message.error('');
//}
